const values = {
    "PACKAGE_REMITTANCE": "Envio de paquete"
}

export default values;